import React from 'react'
import { Link } from 'react-router-dom'

const networks = {
  "📰 Feed": '/feed',
  "LinkedIn": 'https://linkedin.com/in/sergimiral',
  "Twitter": 'https://twitter.com/sergimiral',
  "Email": 'mailto:sergimiral@gmail.com',
}

const Footer = () =>
  <footer>
    <section className="container">
      {/* <aside>
        <Link to="/">© {new Date().getFullYear()} Sergi Miral, Inc.</Link>
      </aside> */}
      <aside className="link-border">
        {Object.keys(networks).map((network, i) =>
          <Link to={networks[network]} target="_blank" key={i}>{network}</Link>
        )}
      </aside>
    </section>
  </footer>

export default Footer



// WEBPACK FOOTER //
// src/javascripts/components/Footer.js